<div class="bot-page-main">
  <app-header-bot></app-header-bot>
  
  <div class="bot-container">
    
    <div class="bot-container-top-row">
      
      <div class="bot-box-top-left">
        <app-recentTrade></app-recentTrade>
      </div>

      <div class="bot-box-chart">
        <div class="botChart">
          <app-chart
            *ngIf="chartStatus"
            class="trade_chart baseblock_wrapper"
            [chartData]="chartData"
          ></app-chart>
        </div>
      </div>

      <div class="bot-box-top-right">
        <app-TopGainer></app-TopGainer>
      </div>
      
    </div>
    
    <div class="bot-history mt-3">
      <app-adminBotorderhistory (botSelected)="onBotSelected($event)">
        </app-adminBotorderhistory>
    </div>
    
  </div>
</div>